import React, {useState, useEffect} from "react";
import {useSelector, useDispatch} from 'react-redux';
import {Button, Layout, Row, Typography} from "antd";
import {
    MenuFoldOutlined,
    MenuUnfoldOutlined,
    SearchOutlined,
    ArrowLeftOutlined,
    ReloadOutlined
} from '@ant-design/icons';
import Logo from './Logo';
import NavProfile from './NavProfile';
import {toggleCollapsedNav, onMobileNavToggle} from 'store/slices/themeSlice';
import {NAV_TYPE_TOP, SIDE_NAV_COLLAPSED_WIDTH, SIDE_NAV_WIDTH} from 'constants/ThemeConstant';
import utils from 'utils'

const {Header} = Layout;
const {Text} = Typography;

export const HeaderNav = props => {

    const {isMobile} = props;

    const [searchActive, setSearchActive] = useState(false);

    const dispatch = useDispatch()


    const navCollapsed = useSelector(state => state.theme.navCollapsed)
    const mobileNav = useSelector(state => state.theme.mobileNav)
    const navType = useSelector(state => state.theme.navType)
    const headerNavColor = useSelector(state => state.theme.headerNavColor)
    const currentTheme = useSelector(state => state.theme.currentTheme)
    const direction = useSelector(state => state.theme.direction)

    const onSearchActive = () => {
        setSearchActive(true)
    }

    const onSearchClose = () => {
        setSearchActive(false)
    }

    const onToggle = () => {
        if (!isMobile) {
            dispatch(toggleCollapsedNav(!navCollapsed))
        } else {
            dispatch(onMobileNavToggle(!mobileNav))
        }
    }

    const isNavTop = navType === NAV_TYPE_TOP ? true : false

    const mode = () => {
        if (!headerNavColor) {
            return utils.getColorContrast(currentTheme === 'dark' ? '#00000' : '#ffffff')
        }
        return utils.getColorContrast(headerNavColor);
    }

    const navMode = mode();

    const getNavWidth = () => {
        if (isNavTop || isMobile) {
            return '0px';
        }
        if (navCollapsed) {
            return `${SIDE_NAV_COLLAPSED_WIDTH}px`;
        } else {
            return `${SIDE_NAV_WIDTH}px`;
        }
    }

    useEffect(() => {
        if (!isMobile) {
            onSearchClose();
        }
    })

    const org = useSelector(state => state.auth.org)

    if (window.ISAPPMODAL === true) {
        return null
    }

    return (
        <Header className={`app-header ${navMode}`} style={{backgroundColor: headerNavColor}}>
            <div className={`app-header-wrapper ${isNavTop ? 'layout-top-nav' : ''}`}>
                <Logo logoType={navMode}/>
                <div className="nav" style={{width: `calc(100% - ${getNavWidth()})`}}>
                    <div className="nav-left">

                        <div className="nav-item" onClick={onToggle}>
                            <div className="d-flex align-items-center">
                                {navCollapsed ? <MenuUnfoldOutlined className="nav-icon"/> :
                                    <MenuFoldOutlined className="nav-icon"/>}
                            </div>


                            {/*(
								<ul className="ant-menu ant-menu-root ant-menu-horizontal">
									{
										isMobile ?
											<li className="ant-menu-item ant-menu-item-only-child" onClick={() => {onSearchActive()}}>
												<SearchOutlined />
											</li>
											:
											<li className="ant-menu-item ant-menu-item-only-child" style={{cursor: 'auto'}}>
												<SearchInput mode={mode} isMobile={isMobile} />
											</li>
									}
								</ul>
							)*/}
                        </div>

                        {isMobile && (
                            <Row>

                                <div className="nav-item" onClick={() => window.history.go(-1)}>
                                    <ArrowLeftOutlined/>
                                </div>

                                <div className="nav-item" onClick={() => window.location.reload()}>
                                    <ReloadOutlined/>
                                </div>
                            </Row>
                        )}



                        {!isMobile && (
                            <div className="nav-item">
                                <a href={"https://app.unisoft.world"}>
                                    <img src={"/img/bouton-new-dashboard.png"} style={{width:450,height:40,objectFit:"cover"}}/>
                                </a>
                            </div>
                        )}


                    </div>
                    <div className="nav-right">
                        <NavProfile/>
                    </div>
                </div>
            </div>
        </Header>
    )
}

export default HeaderNav;
